import * as roles from '@/constants/roles';
import store from '@/store/';
import roleUtil from '@/utils/roleUtil';

const routes = [
    {
        path: '/',
        meta: {
            requiresAuth: false
        },
        component: () => import('@/views/Login.vue'),
        // Redirect if already signed in
        beforeEnter: (to, from, next) => {
            if (store.state.auth.authenticated) {
                // Redirect to role specific home page
                next(roleUtil.getRoleHome(store.state.auth.user));
            } else {
                next();
            }
        }
    },
    {
        // Routes for Operators
        path: roles.OPERATOR_HOME, // '/op'
        meta: {
            requiresAuth: true,
            authorize: [roles.OPERATOR]
        },
        component: () => import('@/views/DashboardBase.vue'),
        children: [
            {
                path: '',
                component: () => import('@/views/Home.vue')
            },

            // Partner orders
            ////////////////////
            {
                name: 'op-restaurantorder-list',
                path: 'restaurantorders',
                component: () => import('@/views/op/RestaurantOrderList.vue')
            },
            {
                name: 'op-restaurantorder-create',
                path: 'restaurantorders/create',
                component: () => import('@/views/op/RestaurantOrderCreate.vue')
            },
            {
                name: 'op-restaurantorder-show',
                path: 'restaurantorders/:order_id',
                component: () => import('@/views/op/RestaurantOrderShow.vue')
            },
            {
                name: 'op-restaurantorder-edit',
                path: 'restaurantorders/:order_id/edit',
                component: () => import('@/views/op/RestaurantOrderEdit.vue')
            },

            // Job orders
            /////////////
            {
                name: 'op-joborder-list',
                path: 'joborders',
                component: () => import('@/views/op/JobOrderList.vue')
            },
            {
                name: 'op-joborder-create',
                path: 'joborders/create',
                component: () => import('@/views/op/JobOrderCreate.vue')
            },
            {
                name: 'op-joborder-show',
                path: 'joborders/:order_id',
                component: () => import('@/views/op/JobOrderShow.vue')
            },
            {
                name: 'op-joborder-edit',
                path: 'joborders/:order_id/edit',
                component: () => import('@/views/op/JobOrderEdit.vue')
            },

            // Couriers
            ///////////
            {
                name: 'op-courierinfo-list',
                path: 'courierinfos',
                component: () => import('@/views/op/CourierList.vue')
            },
            {
                name: 'op-courierinfo-create',
                path: 'courierinfos/create',
                component: () => import('@/views/op/CourierCreate.vue')
            },
            {
                name: 'op-courierinfo-show',
                path: 'courierinfos/:courierinfo_id',
                component: () => import('@/views/op/CourierShow.vue')
            },
            {
                name: 'op-courierinfo-edit',
                path: 'courierinfos/:courierinfo_id/edit',
                component: () => import('@/views/op/CourierEdit.vue')
            },

            // Restaurants
            //////////////
            {
                name: 'op-restaurant-list',
                path: 'restaurants',
                component: () => import('@/views/op/RestaurantList.vue')
            },
            {
                name: 'op-restaurant-create',
                path: 'restaurants/create',
                component: () => import('@/views/op/RestaurantCreate.vue')
            },
            {
                name: 'op-restaurant-show',
                path: 'restaurants/:restaurant_id',
                component: () => import('@/views/op/RestaurantShow.vue')
            },
            {
                name: 'op-restaurant-edit',
                path: 'restaurants/:restaurant_id/edit',
                component: () => import('@/views/op/RestaurantEdit.vue')
            },

            // Settlements
            ////////////
            {
                name: 'op-restaurant-pending-settlements',
                path: 'restaurant-pending-settlements',
                component: () =>
                    import('@/views/op/RestaurantPendingSettlements.vue')
            },

            // Locations
            ////////////
            {
                name: 'op-location-list',
                path: 'locations',
                component: () => import('@/views/op/LocationList.vue')
            },
            {
                name: 'op-location-servicecharges',
                path: 'locations/:location_id/servicecharges',
                component: () =>
                    import('@/views/op/LocationServicechargeList.vue')
            }
        ]
    },
    {
        // Routes for Restaurateurs
        path: roles.RESTAURATEUR_HOME, // '/rest'
        meta: {
            requiresAuth: true,
            authorize: [roles.RESTAURATEUR]
        },
        component: () => import('@/views/DashboardBase.vue'),
        children: [
            {
                path: '',
                component: () => import('@/views/Home.vue')
            },
            {
                name: 'rest-order-list',
                path: 'orders',
                component: () => import('@/views/rest/OrderList.vue')
            },
            {
                name: 'rest-order-create',
                path: 'orders/create',
                component: () => import('@/views/rest/OrderCreate.vue')
            },
            {
                name: 'rest-order-show',
                path: 'orders/:order_id',
                component: () => import('@/views/rest/OrderShow.vue')
            },
            {
                name: 'rest-order-edit',
                path: 'orders/:order_id/edit',
                component: () => import('@/views/rest/OrderEdit.vue')
            },
            {
                name: 'rest-settlements',
                path: 'settlements',
                component: () => import('@/views/rest/SettlementView.vue')
            }
        ]
    },
    {
        // Common routes
        path: '',
        meta: {
            requiresAuth: true,
            authorize: [roles.OPERATOR, roles.RESTAURATEUR]
        },
        component: () => import('@/views/DashboardBase.vue'),
        children: [
            {
                name: 'password-change',
                path: 'password-change',
                component: () => import('@/views/PasswordChange.vue')
            }
        ]
    }
];

export default routes;
